// ============================================
// FILE: src/components/DesktopFooter.jsx
// Shared footer used across all desktop (>=1024px) pages.
// ============================================

import React from 'react';

const DesktopFooter = ({
  appSettings,
  setActiveTab,
  setShowFavorites,
  setSelectedCategory,
  onOpenOffers,
}) => {
  const logoSrc = `${process.env.PUBLIC_URL || ''}/logo.png`;
  const go = (tab) => () => setActiveTab && setActiveTab(tab);

  return (
    <footer className="bg-white border-t border-[#eaeaec] mt-8">
      <div className="max-w-[1280px] mx-auto px-8 py-12 grid grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={logoSrc} alt="logo" className="w-9 h-9 rounded object-contain" />
            <h3 className="app-brand-title text-lg" style={{ color: '#1b1b1b' }}>{appSettings?.appName || 'DealStore'}</h3>
          </div>
          <p className="text-sm text-[#94969f] leading-relaxed">Fresh picks &amp; daily savings delivered to your door.</p>
        </div>
        <div>
          <h4 className="text-sm font-bold text-[#282c3f] mb-3">Shop</h4>
          <ul className="space-y-2 text-sm text-[#94969f]">
            <li><button onClick={() => { setSelectedCategory && setSelectedCategory('All'); setActiveTab && setActiveTab('home'); }} className="hover:text-[#ff3f6c]">All Products</button></li>
            <li><button onClick={() => onOpenOffers && onOpenOffers('all')} className="hover:text-[#ff3f6c]">Offers</button></li>
            <li><button onClick={go('subscriptions')} className="hover:text-[#ff3f6c]">Subscriptions</button></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-bold text-[#282c3f] mb-3">Account</h4>
          <ul className="space-y-2 text-sm text-[#94969f]">
            <li><button onClick={go('orders')} className="hover:text-[#ff3f6c]">My Orders</button></li>
            <li><button onClick={() => setShowFavorites && setShowFavorites(true)} className="hover:text-[#ff3f6c]">Favorites</button></li>
            <li><button onClick={go('profile')} className="hover:text-[#ff3f6c]">Profile</button></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-bold text-[#282c3f] mb-3">Help</h4>
          <ul className="space-y-2 text-sm text-[#94969f]">
            <li><button onClick={go('about')} className="hover:text-[#ff3f6c]">About Us</button></li>
            <li><button onClick={go('help')} className="hover:text-[#ff3f6c]">Help &amp; Support</button></li>
            <li><button onClick={go('terms')} className="hover:text-[#ff3f6c]">Terms</button></li>
            <li><button onClick={go('privacy')} className="hover:text-[#ff3f6c]">Privacy Policy</button></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-100">
        <div className="max-w-[1280px] mx-auto px-8 py-5 text-center text-xs text-[#94969f]">
          © {new Date().getFullYear()} {appSettings?.appName || 'DealStore'}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default DesktopFooter;
